import React from "react";
import { Typography, Avatar, Box } from "@mui/material";

export default function StatsCard({ stat }) {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2,
        transition: "box-shadow 0.2s ease",
        "&:hover": {
          boxShadow: 4,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flex: 0 }}>
          <Avatar
            sx={{
              bgcolor: stat.bgColor,
              color: stat.color,
              width: 40,
              height: 40,
            }}
          >
            {stat.icon}
          </Avatar>
        </Box>
        <Box sx={{ flex: 1, px: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {stat.value}
          </Typography>
        </Box>
        <Box sx={{ flex: 1, textAlign: "right" }}>
          <Typography variant="body2" color="text.secondary">
            {stat.title}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: stat.color, fontWeight: 500 }}
          >
            {stat.change}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
